import React from "react";
import {
  Container,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  useTheme,
} from "@mui/material";
import { BackgroundPage, Body1, H6, Icone } from "../components";
import { AnimacaoCashback } from "../components/sem-pesquisa";

const STR = {
  title: "Seja bem-vindo !",
  description: "Esta é a rotina de manutenção de cashback das lojas",
  description2: "Os recursos disponíveis são:",
  option1: "Consultar Cashback do cliente por CPF",
  option2: "Visualizar todos os cashbacks da loja",
  option3: "Validar e marcar um cashback como utilizado",
  option4: "Entre outros recursos",
  footer: "Utilize o menu acima para navegar entre as rotinas",
  footerMobile: "Utilize o menu abaixo para navegar entre as rotinas",
};

function Home() {
  const isMobile = useTheme()?.isMobile;
  const options = [
    { label: STR.option1, icon: "Search" },
    { label: STR.option2, icon: "List" },
    { label: STR.option3, icon: "Check" },
    { label: STR.option4, icon: "More" },
  ];
  return (
    <BackgroundPage>
      <Container maxWidth="md" sx={{ py: 2 }}>
        <Paper elevation={3}>
          <H6>{STR.title}</H6>
          <Body1 align="center">{STR.description}</Body1>
          <Body1 fontWeight="bold" align="center">
            {STR.description2}
          </Body1>
          <List>
            {options.map((option, index) => (
              <ListItem key={index}>
                <ListItemIcon>
                  <Icone icone={option.icon} />
                </ListItemIcon>
                <ListItemText primary={option.label} />
              </ListItem>
            ))}
          </List>
          <AnimacaoCashback />
          <Body1 align="center">
            {isMobile ? STR.footerMobile : STR.footer}
          </Body1>
        </Paper>
      </Container>
    </BackgroundPage>
  );
}

Home.route = "/home";

export default Home;
